<template>
    <article class="ath-panel pr dh-a c-el-panel-bg"
        :class="[UIMobile ? '' : 'br-m bf bs-s']">
        <slot name="content"></slot>
    </article>
</template>

<script>
import UIMobileMixin from '../../mixins/UIMobile';
export default {
    name: 'mead-panel',
    mixins: [UIMobileMixin],
};
</script>
